/* ENGORI — Waehrungszeichen hinter den Betrag. Angelegt 07.09.2026.

   Shopify stellt das Format zentral unter Einstellungen > Allgemein >
   Waehrungsformatierung ein; dort steht "€{{amount_with_comma_separator}}".
   Diese Einstellung laesst sich NICHT ueber die API aendern — am 07.09.2026
   geprueft: `PUT /admin/api/2025-07/shop.json` antwortet 406, und im
   Admin-GraphQL 2025-07 gibt es kein Feld dafuer ("shopSettingsUpdate"
   existiert nicht). Deshalb dreht dieses Skript die Betraege im Storefront.

   Grenze, die bleibt: Der Checkout gehoert Shopify und rendert weiter
   "€49,90". Wer das auch dort will, muss die Einstellung im Admin von Hand
   umstellen — das ist der einzige Weg.

   Vorsicht walten lassen: nur Textknoten, keine Skripte, Styles, Eingabefelder
   oder bereits gedrehten Betraege. */
(function () {
  'use strict';

  var UEBERSPRINGEN = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, NOSCRIPT: 1, TEMPLATE: 1 };

  /* "€49,90 EUR" zuerst, sonst bliebe die Waehrung doppelt stehen.
     Danach der Normalfall, Minuszeichen eingeschlossen ("-€49,90"). */
  var MIT_WAEHRUNG = /(-?)€\s?(\d[\d.]*(?:,\d{1,2})?)\s?EUR/g;
  var NORMAL = /(-?)€\s?(\d[\d.]*(?:,\d{1,2})?)/g;

  function drehe(text) {
    return text
      .replace(MIT_WAEHRUNG, '$1$2 €')
      .replace(NORMAL, '$1$2 €');
  }

  function bearbeite(wurzel) {
    if (!wurzel) return;
    var lauf = document.createTreeWalker(wurzel, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('€') === -1) return NodeFilter.FILTER_REJECT;
        var el = n.parentNode;
        if (!el || UEBERSPRINGEN[el.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var treffer = [], k;
    while ((k = lauf.nextNode())) treffer.push(k);
    treffer.forEach(function (n) {
      var neu = drehe(n.nodeValue);
      if (neu !== n.nodeValue) n.nodeValue = neu;
    });
  }

  function alles() { bearbeite(document.body); }

  /* Nachgeladene Inhalte — Warenkorb, Staffel, Popup — kommen spaeter.
     15.09.2026: Frueher wurde hier ueber requestAnimationFrame gebuendelt.
     Faellt dieser Frame aus (verdeckter oder gedrosselter Tab), blieb die
     Sperre haengen und jede weitere Mengenaenderung zeigte "€29,95".
     Jetzt direkt im Beobachter, nur fuer die geaenderten Knoten. Der
     Beobachter laeuft vor dem naechsten Zeichnen, also ohne Aufblitzen. Die
     eigene Textaenderung loest genau eine Runde ohne Treffer aus und endet dort. */
  function start() {
    alles();
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (aend) {
      for (var i = 0; i < aend.length; i++) {
        var a = aend[i];
        if (a.type === 'characterData') {
          if (a.target && a.target.parentNode) bearbeite(a.target.parentNode);
          continue;
        }
        for (var j = 0; j < a.addedNodes.length; j++) {
          var n = a.addedNodes[j];
          if (n.nodeType === 1) bearbeite(n);
          else if (n.nodeType === 3 && n.parentNode) bearbeite(n.parentNode);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
